import arch from '../content/woodworking/arch.jpg';
import ringOpen from '../content/woodworking/ring_box_open.jpg';
import ringClosed from '../content/woodworking/ring_box_closed.jpg';
import mantel from '../content/woodworking/mantel.jpg';
import planter from '../content/woodworking/planter.jpg';
import standBooks from '../content/woodworking/phonestand_books.jpg';
import standBrush from '../content/woodworking/phonestand_paintbrush.jpg';

export interface Piece {
  src: string;
  title: string;
}

export const pieces: Piece[] = [
  { src: arch, title: 'Wedding arch & podium' },
  { src: mantel, title: 'Floating mantel' },
  { src: ringOpen, title: 'Ring box' },
  { src: planter, title: 'Herb planter' },
  { src: standBooks, title: 'Phone stand' },
  { src: ringClosed, title: 'Ring box' },
  { src: standBrush, title: 'Phone stand' },
];
